import { useRef } from "react";
import { T } from "./tokens";

interface WaveFormProps {
  bars?: number;
  height?: number;
  active?: boolean;
  color?: string;
  intensity?: number;
}

export function WaveForm({ bars = 32, height = 48, active = true, color = T.gold, intensity = 1 }: WaveFormProps) {
  const phases = useRef(
    Array.from({ length: bars }, (_, i) => Math.sin(i * 0.7) * 0.4 + 0.5)
  ).current;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3, height, justifyContent: "center" }}>
      {phases.map((p, i) => (
        <div
          key={i}
          style={{
            width: 3,
            height: "100%",
            borderRadius: 2,
            background: color,
            opacity: 0.55 + p * 0.45,
            transformOrigin: "center",
            animation: active ? `nig-wave ${0.7 + p * 0.8}s ${T.ease} ${i * 0.04}s infinite` : "none",
            transform: `scaleY(${0.3 + p * 0.5 * intensity})`,
          }}
        />
      ))}
    </div>
  );
}

interface WaveStaticProps {
  width?: number;
  height?: number;
  color?: string;
  opacity?: number;
}

export function WaveStatic({ width = 240, height = 48, color = T.gold, opacity = 0.45 }: WaveStaticProps) {
  const bars = 60;
  const arr = Array.from({ length: bars }, (_, i) => {
    const x = i / bars;
    return (
      0.25 +
      Math.abs(Math.sin(i * 0.55)) * 0.55 +
      Math.cos(i * 0.21) * 0.2 +
      (x > 0.5 ? -0.1 : 0)
    );
  });
  return (
    <svg width={width} height={height} viewBox={`0 0 ${bars * 4} ${height}`} preserveAspectRatio="none">
      {arr.map((v, i) => {
        const h = Math.max(2, Math.min(height, v * height));
        return (
          <rect
            key={i}
            x={i * 4}
            y={(height - h) / 2}
            width="2.4"
            height={h}
            rx="1"
            fill={color}
            opacity={opacity + (i / bars) * 0.2}
          />
        );
      })}
    </svg>
  );
}
